import webBiLogger from '@wix/web-bi-logger';
import { Logger } from '@wix/web-bi-logger/dist/src/types';
import { maMiscClick, maSettingsAdjustments } from '@wix/bi-logger-members-app-users/v2';
import { reportMemberSubmitted, actionButtonClicked } from '@wix/bi-logger-members-app-uou/v2';

import Wix from './wix-sdk-polyfill';
import { MEMBERS_ABOUT_APP_DEF_ID } from '../../../../test/env/constants';

// eslint-disable-next-line no-extra-boolean-cast
export const toBIBoolean = (value: boolean) => (Boolean(value) ? 1 : 0);

enum ClickActions {
  SHOW = 'show',
  HIDE = 'hide',
  CLICK = 'click',
}

const toVisibilityString = (value: boolean): string => (value ? ClickActions.SHOW : ClickActions.HIDE);

const ABOUT = 'about';

export enum MA_BLOG_REFS {
  BLOG_BWP_VIEW_POST = 'blog-bwp-view-post',
  BLOG_BWP_CREATE_POST = 'blog-bwp-create-post',
}

interface BaseProps {
  biToken: string;
  instance_id: string;
  client_id: string;
  app_id: string;
  visitor_id: string;
}

const getBaseProps = (): BaseProps => {
  return {
    biToken: Wix?.Utils?.getInstanceValue('biToken') || '',
    instance_id: Wix?.Utils?.getInstanceValue('instanceId') || '',
    client_id: Wix?.Utils?.getInstanceValue('uid') || '',
    app_id: MEMBERS_ABOUT_APP_DEF_ID,
    visitor_id: Wix.Utils.getInstanceValue('aid') || '',
  };
};

export class BIService {
  logger: Logger;
  baseProps: BaseProps = { biToken: '', instance_id: '', client_id: '', app_id: '', visitor_id: '' };

  constructor() {
    this.logger = webBiLogger.factory().logger();
    this.baseProps = getBaseProps();
  }

  getDefaultParams() {
    const props = this.baseProps;
    return {
      bsi: props.biToken,
      metaSiteId: props.biToken,
      visitorId: props.visitor_id,
      appId: props.visitor_id,
      instanceId: props.app_id,
      siteOwnerId: props.client_id,
    };
  }

  maSettingsAdjustments(action: boolean, property: string, section: string = ABOUT) {
    this.logger.report(
      maSettingsAdjustments({ ...this.baseProps, action: toVisibilityString(action), property, section }),
    );
  }

  maSettingsTabChange(section: string) {
    this.logger.report(maSettingsAdjustments({ ...this.baseProps, action: ClickActions.CLICK, section }));
  }

  maMiscClick(referralInfo: MA_BLOG_REFS) {
    this.logger.report(maMiscClick({ ...this.baseProps, referralInfo }));
  }

  maActionButtonClick(action_type: string, params: any) {
    this.logger.report(
      actionButtonClicked({
        ...this.baseProps,
        ...params,
        site_member_id: this.baseProps.client_id,
        action_type,
      }),
    );
  }

  maReportMemberSubmitted(reason: string, details: string, member_chosen: string) {
    this.logger.report(
      reportMemberSubmitted({
        ...this.baseProps,
        siteMemberId: this.baseProps.client_id,
        member_chosen,
        reason,
        details,
      }),
    );
  }
}

export const getBIService = () => new BIService();
